import {Alert, Breadcrumb, Button} from "antd";
import {DashboardWrapper} from "../../../../layouts/dashboard-wrapper";
import {Link} from "react-router-dom";
import {StyledPageWrapper} from "../../../../styles/dashboard/calls/calls";
import {CanvaTemplateWidget} from "../../../../components/widgets/canva-template-widget";
import {ErrorBoundary} from "react-error-boundary";
import {CreateProductMultiStepFormWrapper} from "../../../../products/useCases/create-product/multi-step/multi-step-form-wrapper";
import {CreateProductContextWrapper} from "../../../../products/useCases/create-product/context/create-product/context-wrapper";
import {CreateProductFormSteps} from "../../../../products/useCases/create-product/multi-step/create-product-steps";
import {StyledHideStepsOnMobile} from "../../../../components/offering-form/general/steps/styles";

export function AddNewProductPage() {
  return (
    <DashboardWrapper pageTitle="Add Product">
      <CreateProductContextWrapper>
        <Breadcrumb>
          <Breadcrumb.Item>
            <Link to="/products">Product</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>Create a new product</Breadcrumb.Item>
        </Breadcrumb>
        <StyledPageWrapper>
          <div className="main-area">
            <ErrorBoundary
              FallbackComponent={({error, resetErrorBoundary}) => (
                <>
                  <div style={{marginTop: "1.8rem"}}>
                    <Alert
                      message="Sorry, something went wrong."
                      showIcon
                      description={error.message}
                      type="error"
                      action={
                        <Button
                          onClick={() => {
                            resetErrorBoundary();
                          }}
                          size="small"
                          danger
                        >
                          Reset
                        </Button>
                      }
                    />
                  </div>
                </>
              )}
            >
              <CreateProductMultiStepFormWrapper />
            </ErrorBoundary>
          </div>
          <div className="widget-area">
            <StyledHideStepsOnMobile>
              <CreateProductFormSteps />
            </StyledHideStepsOnMobile>
            <CanvaTemplateWidget url="https://www.canva.com/design/DAGPzxhigYA/gFsU5XQQ4j5DlxQnccruhg/view?utm_content=DAGPzxhigYA&utm_campaign=designshare&utm_medium=link&utm_source=publishsharelink&mode=preview" />
          </div>
        </StyledPageWrapper>
      </CreateProductContextWrapper>
    </DashboardWrapper>
  );
}
